import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {DocumentDetail} from "./document-detail";

const DocumentDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/documents');
    }

    return (
        <DocumentDetail id={id} onClose={onClose}/>
    )

});

export default DocumentDetailPage;